<template>
  <div>
    <ScrollView
      class="DashScrollContainer"
      :refreshing="refreshing"
      @onRefresh="onRefresh"
      :empty="data.length === 0"
    >
      <div class="chart-pie d-flex align-items-center mx-4 px-4">
        <CChartLine
          :wrapper="false"
          :labels="labels"
          :options="options"
          :datasets="data_"
          class="flex-grow-1"
        />
        
        <div class="conceptos">
          <Item
            v-for="(itm, i) of conceptos"
            class="item"
            :key="`link_${i}`"
            :isSubGrafica="itm.isSubGrafica"
            :to="{
              name: 'AnalyticsChart',
              params: { ...itm.subGrafica, goBack }
            }"
          >
            <i class="dot" :style="`--bg: ${itm.color}`" />
            <span class="label">{{ itm.label }}:</span>
            <span class="valor">{{ itm.value }}</span>
            
          </Item>

          <Item
            v-for="(itm, i) of subGraficaEstructura"
            class="item sub-grafica"
            :key="`link_estructura_${i}`"
            isSubGrafica
            :to="{
              name: 'AnalyticsChart',
              params: { ...itm.subGrafica, goBack }
            }"
          >
            <i class="dot" :style="`--bg: ${itm.color}`" />
            <span class="label">{{ itm.label }}</span>
            
          </Item>
        </div>
      </div>
      <template slot="Empty">
        <slot name="Empty" />
      </template>
    </ScrollView>
  </div>
</template>

<script>
import moment from "moment";

import { CChartLine } from "@coreui/vue-chartjs";
import { customTooltips } from '@coreui/coreui-chartjs/dist/js/coreui-chartjs.js'

import colorsS from "../colors.json";
import Item from "../Item.vue";

const colors = JSON.parse(JSON.stringify(colorsS));
export default {
  name: "LineDate",
  components: {
    CChartLine,
    Item
  },
  props: {
    bezier: {
      type: Boolean,
      default: false
    },
    withDots: {
      type: Boolean,
      default: false
    },
    refreshing: {
      type: Boolean,
      default: false
    },
    onRefresh: {
      type: Function,
      default: () => {}
    },
    data: {
      type: Array,
      default: () => []
    },
    estructura: {
      type: Object,
      default: () => ({})
    },
    moneda: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    subGraficaEstructura() {
      return (this.estructura?.subGrafica||[]).map(m => {
        const {label, ...subGrafica} = m
        if(Array.isArray(subGrafica.filtros)&&subGrafica.filtros.length===0){
          subGrafica.filtros = {}
        }
        return {
          label,
          subGrafica
        };
      });
    },
    labelList_() {
        return this.data.reduce(
            (v, graf) => [...new Set([...v, ...graf.data.map(m => m.fecha)])],
            [],
        )
    },
    labels() {
      return this.labelList_.map(date => moment(date, 'YYYY-MM-DD').format('DD/MM/YY'));
    },
    data_() {
      return this.data.map((graf,i) => {
        let last_val = 0;
        return {
            label: graf.grafica,
            backgroundColor: `${colors[i % colors.length]}90`,
            borderColor: colors[i % colors.length],
            pointBackgroundColor: colors[i % colors.length],
            pointBorderColor: colors[i % colors.length],
            data: this.labelList_.map(fecha => {
                last_val =
                graf.data?.find(f => f.fecha === fecha)?.valor || last_val;
                return last_val;
            }),
            tension: this.bezier?0.5:0,
            pointRadius: this.withDots?3:0.9
          }
      });
    },
    conceptos(){
        return this.data.map((m,i)=>({
            label: m.grafica,
            color: colors[i % colors.length],
            value: this.$formatter(
                m.data.reduce((v, c) => v + c.valor, 0),
                this.moneda,
            )
        }))
    },
    goBack() {
      return this.$route?.params;
    }
  },
  data() {
    return {
      options: {
        onClick: (evt, item) => {
          if (item.length) {
            console.log({evt,item})
            debugger
            // const _item_ = this.data[item[0]._index];
            // const m = _item_.subGrafica;
            // if (m) {
            //   this.$router.push({
            //     name: "AnalyticsChart",
            //     params: { ...m, goBack: this.goBack }
            //   });
            // }
          }
        },
        tooltips: {
            enabled: false,
            custom: customTooltips,
            mode: 'point',
            callbacks: {
                label:(tooltipItem, chart)=> {
                  const {datasetIndex} = tooltipItem
                  const {label} = chart?.datasets?.[datasetIndex]
                  return [`${label}: ${this.$formatter(tooltipItem.yLabel, this.moneda)}`]
                },
                labelColor(tooltipItem, chart) {
                    function getValue(prop) {
                        return typeof prop === 'object' ? prop[tooltipItem.index] : prop
                    }
                    const dataset = chart.data.datasets[tooltipItem.datasetIndex]
                    //tooltipLabelColor is coreUI custom prop used only here
                    const backgroundColor = getValue(
                        dataset.tooltipLabelColor ||
                        dataset.pointHoverBackgroundColor ||
                        dataset.borderColor ||
                        dataset.backgroundColor
                    )
                    return {
                        backgroundColor
                    }
                }
            }
        }
      },
    };
  },
  created() {
  }
};
</script>

<style lang="scss" scoped>
.chart-pie {
  min-height: 400px;
  height: 60vh;
  .conceptos {
    min-width: 200px;
    max-width: 300px;
    .item {
      gap: 5px;
      display: flex;
      font-size: 1rem;
      margin: 10px 5px;
      align-items: center;
      transition: transform 0.25s;
      color: #000;

      &:is(:active, &:visited, &:hover) {
        color: unset;
        text-decoration: none;
      }
      .dot {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        display: inline-grid;
        place-content: center;
        font-size: 10px;
        color: #fff;
        font-weight: bold;
        background-color: var(--bg, #fff);
        box-shadow: 0px 0px 2px black;
        text-shadow: 0px 0px 2px black;
      }
      .label {
        font-weight: bold;
      }
      .valor {
        justify-self: flex-end;
        text-align: right;
        flex-grow: 1;
      }
      &.sub-grafica:hover {
        transform: scale(1.1);
      }
    }
  }
}
</style>
